import request from 'configuration/request';
import { httpBuildQuery } from 'helpers/utils';

export const FeedbackApi = {
  feedbackList: (query) => {
    return request({
      url: `/transfer_act_feedback/list/${httpBuildQuery(query)}`,
      method: 'GET',
    });
  },

  feedbackQuestionsList: () => {
    return request({
      url: '/transfer_act_feedback_questions/list/',
      method: 'GET',
    });
  },
};
